import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import {
    IDoctor,
    IServ,
    ISpec,
    IDep,
    IRecTalon,
    IRnumbDate,
    Department,
    ITalonsDaySetParams,
    ITalonModal,
    IFilial,
} from '../../../interfaces/record.interface';
import { ConfigService } from 'src/app/services/application/config.service.';
import moment, { Moment } from 'moment';
import { MatCalendar } from '@angular/material/datepicker';
import { lastValueFrom, map, Observable } from 'rxjs';
import { strToDate } from '../../application/global.function';
import { RecordService } from 'src/app/services/record.service';
import { AlertService } from 'src/lib/ariadna/alert';
import { CalendarService } from 'src/app/services/calendar.service';
import { NewTalonComponentMobile } from 'src/app/modals/new-talon-mobile/talon.component';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocInfoModalComponent } from 'src/app/modals/doc-info-modal/doc-info-modal.component';

export interface IFilialDep {
    keyid: number;
    dep_id: number;
    text: string;
    dep_name: string;
    gps_coordinates?: string;
    addr?: string;
}

@Component({
    selector: 'app-mobile-appointment',
    templateUrl: './mobile-appointment.component.html',
    styleUrls: ['./mobile-appointment.component.scss'],
})
export class MobileAppointmentComponent implements OnInit {
    @Input() params!: IRnumbDate;
    @Output() talonPickerClosed = new EventEmitter();
    @ViewChild('calendar') calendar!: MatCalendar<moment.Moment>;

    showCalendarIcon: boolean = true;
    isCalendarActive: boolean = false;
    showDropdown: boolean = false;
    isSlideRight: boolean = false;
    isSlideLeft: boolean = false;
    selectedDay: Moment | null = moment();
    selectedSrv: IServ | null = null;
    activeDays: Moment[] = []; // NOT sorted by date
    talonListFiltered: IRecTalon[] = [];
    loading: boolean = false;
    filialFromParams: IFilial | null = null;

    pickedTalon: IRecTalon | null = null;
    selectedDeps: Array<number> = []; // Список выбранных депов
    depPicked: boolean = false;
    selectedDep: IDep | null = null;
    headerTxt: string = '';
    depList: Department[] = [];

    constructor(
        private configS: ConfigService,
        private rs: RecordService,
        private alertService: AlertService,
        private cs: CalendarService,
        private modal: MatDialog,
        private modalService: NgbModal,
    ) {}

    ngOnInit(): void {
        moment.locale('ru');
        this.loading = true;

        this.activeDays = this.filterActiveDays();
        if (this.activeDays.length > 0) {
            this.selectedDay = this.findFirstActiveDay();
            this.updateHeaderText();
        }
    }

    minDate: moment.Moment = moment().startOf('year');
    maxDate: moment.Moment = moment().endOf('year');
    currentDay: Date | null | undefined = null;

    async ngOnChanges(changes: any) {
        this.filialFromParams = this.params?.Idep
            ? Array.isArray(this.params.Idep)
                ? this.params.Idep[0] || null // ← Берём первый элемент или null
                : this.params.Idep // ← Если это не массив — используем напрямую
            : null;
        if (changes.recDoctors) {
            if (changes.recDoctors.currentValue) {
                this.loading = false;
            }
        }

        if (changes.params) {
            this.loading = true;
            try {
                this.maxDate = moment(changes.params.currentValue.periodEnd);
                await Promise.all([
                    await this.getTalonList(changes.params.currentValue),
                    await this.getDepList(changes.params.currentValue),
                ]).catch((e) => {
                    this.alertService.error(
                        'Не удалось получить список талонов',
                    );
                    console.error(e);
                });

                // Устанавливаем selectedDep после загрузки данных
                // if (this.filialFromParams) {
                this.selectedDep =
                    this.depList.find(
                        (dep) => dep.text === this.filialFromParams?.dep_name,
                    ) || null;
                this.selectedDeps =
                    this.depList.find(
                        (dep) => dep.text === this.filialFromParams?.dep_name,
                    )?.mergedKeyIds || [];
                // }

                this.activeDays = this.filterActiveDays();
                this.selectedDay = this.findFirstActiveDay();
                this.talonListFiltered = this.filterTalons();

                this.updateCalendar();
                this.loading = false;
                this.pickedTalon = null;
                this.currentDay = this.selectedDay?.toDate();
                const data: ITalonsDaySetParams = {
                    dt: this.currentDay ? this.currentDay : new Date(),
                    dep: this.selectedDep ? this.selectedDep : undefined,
                };
                this.initDay(data);
            } catch (e) {
                this.alertService.error('Ошибка получения номерков');
                setTimeout(() => {
                    this.closeComponent();
                }, 1000);
                this.loading = false;
                console.error(e);
            }
        }
    }

    initDay(data: ITalonsDaySetParams) {
        // Фильтр по дню
        // this.selectedDate = data.dt;
        const depId = data.dep && data.dep.keyid > 0 ? data.dep.keyid : 0;

        this.loadDate(depId);
    }
    talonListDay: IRecTalon[] = []; // Массов дней - активный
    calendarEnabled: boolean = true;

    loadDate(depId: number) {
        const dateFilter = Number(moment(this.selectedDay).format('YYYYMMDD'));
        this.headerTxt = `${moment(this.selectedDay).format('DD MMMM YYYY')}`;
        this.talonListDay = this.talonList.filter(
            (item) =>
                item.dtFilter === dateFilter &&
                (item.depid === depId || depId === 0),
        );
        const dates = this.talonListAll
            .map((item) => item.dtFilter)
            .filter((date, index, self) => {
                return self.indexOf(date) === index;
            });
        const months = this.talonListAll
            .map((item) => String(item.dtFilter).substr(0, 6))
            .filter((month, index, self) => {
                return self.indexOf(month) === index;
            });
        this.calendarEnabled = dates.length > 1;

        this.cs.setParams({
            year_begin: Number(moment().format('YYYY')),
            mounth_begin: Number(moment().format('MM')),
            count: months.length,
            cdActive: dates.map((date) => ({
                date: date !== undefined ? date : 0,
            })),
            orderByStart: true,
            MinDate: {
                m: Number(moment().format('MM')),
                y: Number(moment().format('YYYY')),
            },
            selectDate: '',
        });
        this.cs.setSelectedDate(moment(this.selectedDay).format('YYYY-MM-DD'));
    }

    updateCalendar() {
        // if (this.calendar) this.calendar.updateTodaysDate();
    }
    findFirstActiveDay() {
        // if (this.activeDays.length === 0) {
        //     console.log('No active days found');
        //     return null;
        // }

        // let firstActiveDay = this.activeDays[0];
        // this.activeDays.forEach((day) => {
        //     if (firstActiveDay.valueOf() > day.valueOf()) firstActiveDay = day;
        // });
        // return firstActiveDay;
        let firstActiveDay = this.activeDays[0];
        this.activeDays.forEach((day) => {
            if (firstActiveDay.valueOf() > day.valueOf()) {
                firstActiveDay = day;
            }
        });
        return firstActiveDay;
    }
    talonListAll: IRecTalon[] = [];
    talonList: IRecTalon[] = []; // Массов дней - активный
    private async getTalonList(params: IRnumbDate) {
        try {
            this.talonListAll = await lastValueFrom(
                this.rs.getRnumbListv2(params),
            );

            this.talonListAll.forEach((talon, i) => {
                this.talonListAll[i].dtBegin = strToDate(talon.dat_begin_str);
            });
        } catch (error) {
            throw new Error('Failed to fetch talon list');
        }
    }

    private filterActiveDays() {
        // if (!this.selectedDep) {
        //     this.activeDays = this.talonListAll
        //         .map((talon) => moment(strToDate(talon.dat_begin_str)))
        //         .filter((day, index, self) => self.indexOf(day) === index);
        // } else {
        //     this.activeDays = this.talonListAll
        //         // .filter((talon) => talon.depid === this.selectedDep?.keyid)
        //         .map((talon) => moment(strToDate(talon.dat_begin_str)))
        //         .filter((day, index, self) => self.indexOf(day) === index);
        // }
        // return this.activeDays;
        return this.talonListAll
            .map((talon) => moment(strToDate(talon.dat_begin_str)))
            .filter((day, index, self) => self.indexOf(day) === index);
    }

    // private async getDepList(params: IRnumbDate) {
    //     // this.loading = true;
    //     try {
    //         this.depList = await lastValueFrom(this.rs.getDepListv2(params));

    //         if (!this.depList || this.depList.length === 0) {
    //             console.warn(
    //                 'depList is empty. Check backend response or params.'
    //             );
    //         }

    //         // Дополнительная фильтрация
    //         this.depList = this.depList.filter((dep) => {
    //             const deps = new Set();
    //             this.talonListAll.forEach((talon) => deps.add(talon.depid));
    //             return deps.has(dep.keyid);
    //         });

    //         this.depList.unshift({ keyid: -1, text: 'Все' });
    //     } catch (error) {
    //         console.error('Error fetching depList:', error);
    //     }

    // }

    private async getDepList(params: IRnumbDate) {
        try {
            // Получаем полный список подразделений
            const fullDepList: Array<IDep> = await lastValueFrom(
                this.rs.getDepListv2(params),
            );

            // Получаем уникальные depid из talonListAll
            const depsWithTalons = new Set(
                this.talonListAll.map((talon) => Number(talon.depid)),
            );

            // Фильтруем подразделения, у которых есть талоны
            const filteredByTalons = fullDepList.filter((dep: IDep) =>
                depsWithTalons.has(Number(dep.keyid)),
            ); // Теперь фильтруем изначально полученный список депов беря только те, у которых есть талоны

            this.depList = this.mergeDuplicByText(filteredByTalons);

            // Добавляем опцию "Все" в начало
            // this.depList.unshift({ keyid: -1, text: 'Все' });
        } catch (error) {
            console.error('Failed to fetch department list', error);
            this.alertService.error(
                'Не удалось загрузить список подразделений',
            );
            // this.depList = [{ keyid: -1, text: 'Все' }]; // fallback
        }
    }

    private mergeDuplicByText(deps: IDep[]): IDep[] {
        const map = new Map<string, IDep>();
        for (const dep of deps) {
            const existing = map.get(dep.text);
            if (existing) {
                existing.mergedKeyIds!.push(dep.keyid);
            } else {
                map.set(dep.text, { ...dep, mergedKeyIds: [dep.keyid] });
            }
        }
        return Array.from(map.values());
    }

    private removeDuplicates<T>(arr: T[], key: keyof T): T[] {
        const seen = new Set<string | number>();
        return arr.filter((item) => {
            const k = item[key] as string | number;
            if (seen.has(k)) {
                return false;
            }
            seen.add(k);
            return true;
        });
    }

    closeComponent(): void {
        this.talonPickerClosed.emit();
    }

    calendarHandler(): void {
        this.isCalendarActive = !this.isCalendarActive;
    }

    getDocImg(docId?: number): string {
        if (!docId) return '';
        return `${this.configS.getValue('hostBackend')}/img/doc/${docId}.png`;
    }

    getDocImgDefault(event: Event): void {
        const elem = event.target as HTMLImageElement;
        elem.src = `${this.configS.getValue('hostBackend')}/img/doc/not.png`;
    }

    getFullName(doctor?: IDoctor | null): string {
        if (!doctor) return '';
        return `${doctor.l_name || ''} ${doctor.f_name || ''} ${
            doctor.s_name || ''
        }`.trim();
    }

    openDocInfoModal(doc: IDoctor | null, event: Event) {
        event.stopPropagation();

        const modal = this.modalService.open(DocInfoModalComponent);
        modal.componentInstance.doc = doc;
        modal.componentInstance.spec = this.params?.selectedSpec?.text;
    }

    toggleDropdown(): void {
        this.showDropdown = !this.showDropdown;
    }

    placeholderDep(): string {
        if (this.filialFromParams) {
            return this.filialFromParams.dep_name || 'Выберите адрес';
        } else {
            if (this.selectedDep) {
                return this.selectedDep.text;
            }
        }
        return 'Выберите адрес';
    }

    onDateSelected(date: moment.Moment): void {
        this.selectedDay = moment(date.toDate());
        // this.isCalendarActive = false;
        this.updateHeaderText();
        this.talonListFiltered = this.filterTalons();
    }

    prevDate(): void {
        this.pickedTalon = null;
        const currentDate = moment(this.selectedDay).startOf('day');

        // собираем уникальные даты из talonListAll
        const uniqueDates = [
            ...new Set(
                this.talonListAll.map((talon) =>
                    moment(talon.dtBegin).startOf('day').valueOf(),
                ),
            ),
        ].sort((a, b) => a - b);

        const currentIndex = uniqueDates.findIndex(
            (date) => date === currentDate.valueOf(),
        );

        if (currentIndex > 0) {
            const prevDate = moment(uniqueDates[currentIndex - 1]);
            this.clickDate(prevDate);
            this.talonListFiltered = this.filterTalons();
        }
        //Анимация
        this.isSlideLeft = true;
        setTimeout(() => {
            this.isSlideLeft = false;
        }, 1000);
    }

    nextDate(): void {
        this.pickedTalon = null;
        const currentDate = moment(this.selectedDay).startOf('day');

        // собираем уникальные даты из talonListAll
        const uniqueDates = [
            ...new Set(
                this.talonListAll.map((talon) =>
                    moment(talon.dtBegin).startOf('day').valueOf(),
                ),
            ),
        ].sort((a, b) => a - b);

        const currentIndex = uniqueDates.findIndex(
            (date) => date === currentDate.valueOf(),
        );

        if (currentIndex < uniqueDates.length - 1) {
            const nextDate = moment(uniqueDates[currentIndex + 1]);
            this.clickDate(nextDate);
            this.talonListFiltered = this.filterTalons();
        }
        //Анимация
        this.isSlideRight = true;
        setTimeout(() => {
            this.isSlideRight = false;
        }, 1000);
        this.updateHeaderText();
    }

    clickDate(date: moment.Moment) {
        this.selectedDay = moment(date.clone().toDate());

        if (!date) {
            return;
        }
        this.selectedDay = moment(this.selectedDay);
        if (this.selectedDep) {
            // Убедимся, что используем правильное поле keyid
            this.loadDate(this.selectedDep.keyid);
        }
    }
    changeDate(direction: number): void {
        // if (this.selectedDay) {
        //     this.selectedDay = new Date(
        //         this.selectedDay.setDate(this.selectedDay.getDate() + direction)
        //     );
        // }
    }

    isFirstDate(): boolean {
        if (!this.selectedDay || !this.talonListAll.length) return true;

        const uniqueDates = [
            ...new Set(
                this.talonListAll.map((talon) =>
                    moment(talon.dtBegin).startOf('day').valueOf(),
                ),
            ),
        ].sort((a, b) => a - b);

        return (
            moment(this.selectedDay).startOf('day').valueOf() === uniqueDates[0]
        );
    }

    isLastDate(): boolean {
        if (!this.selectedDay || !this.talonListAll.length) return true;

        const uniqueDates = [
            ...new Set(
                this.talonListAll.map((talon) =>
                    moment(talon.dtBegin).startOf('day').valueOf(),
                ),
            ),
        ].sort((a, b) => a - b);

        return (
            moment(this.selectedDay).startOf('day').valueOf() ===
            uniqueDates[uniqueDates.length - 1]
        );
    }

    toggleClass(): void {
        this.calendarHandler();
    }

    clickTalon(event: Event, talon: IRecTalon): void {
        // if (this.talonDisable(talon)) {
        this.pickedTalon = talon;
        // }
    }

    /* Блокировка выбора талона */
    talonDisable(talon: IRecTalon): boolean {
        return this.params?.srv?.is_telemed === talon.is_telemed;
    }

    async openTalonModal(event: MouseEvent, talon: IRecTalon | null) {
        event.stopPropagation();
        if (this.pickedTalon) {
            talon = this.pickedTalon;
        }

        if (talon?.rnumbid !== this.pickedTalon?.rnumbid) {
            this.pickedTalon = talon;
        }

        if (this.params?.srv?.is_telemed !== talon?.is_telemed) {
            this.loading = false;
            return;
        }

        // if (!talon) return;
        let data: ITalonModal = {
            rnumbID: null,
            info: {
                docdepID: this.pickedTalon?.docdepid,
                beginDate: this.pickedTalon?.dtBegin,
            },
            srv: this.params.srv,
            paramCansel: false,
            infoDoc: this.params.infoDoc,
        };

        try {
            if (
                talon?.is_interval &&
                talon.is_interval > 0 &&
                talon.interval_id
            ) {
                // console.log(talon);
                const { guid, err_code, err_text } = await lastValueFrom(
                    this.rs.getRnumbCreateInterval(
                        talon?.interval_id,
                        talon?.dat_begin_str,
                        talon?.dat_end_str,
                    ),
                );

                if (err_code !== 0 || !guid) throw new Error(err_text);
                data.rnumbID = guid;
                await lastValueFrom(
                    this.rs.setRnumbBlStatus(data.rnumbID as number),
                );
            } else if (talon?.rnumbid) {
                data.rnumbID = talon.rnumbid;

                await lastValueFrom(
                    this.rs.setRnumbBlStatus(data.rnumbID as number),
                );
            }

            this.alertService.success(
                `Талон успешно зарезервирован, № талона: ${data.rnumbID}`,
            );

            let dialogRefOptions = {
                width: 'auto',
                // height: '90vh',
                maxWidth: 'auto',
                minWidth: 'auto',
                closeOnNavigation: true,
                data,
            };

            // Check screen width and adjust dialog options if needed
            if (window.matchMedia('(max-width: 768px)').matches) {
                dialogRefOptions.width = '90vw';
                dialogRefOptions.maxWidth = '100vw';
                dialogRefOptions.minWidth = '90vw';
            }

            const modalRef = this.modal.open(
                NewTalonComponentMobile,
                dialogRefOptions,
            );

            modalRef.afterClosed().subscribe((result) => {
                // console.log(result);
                if (result && result.unlockTalon) {
                    lastValueFrom(this.rs.getRnumbUnlock(result.rnumbID))
                        .then((value) => {
                            this.alertService.success(
                                `Талон успешно разблокирован, № талона: ${result.rnumbID}`,
                            );
                        })
                        .catch((error: any) => {
                            this.alertService.error(
                                `Не удалось разблокировать талон с id ${result.rnumbID}: ${error.msg}`,
                            );
                        });
                }
            });
        } catch (error: any) {
            console.error(`Не удалось создать интервал: ${error.msg}`);
            this.alertService.error(
                `Не удалось записаться на номерок: ${error.msg}`,
            );
        }
    }

    // buttonAcceptplaceholder(): string {
    //     return this.pickedTalon ? 'Выбрать' : 'Выберите время';
    // }

    buttonAcceptplaceholder() {
        if (this.pickedTalon) {
            if (this.params?.srv?.is_telemed !== this.pickedTalon?.is_telemed) {
                return 'Это номерок для другой услуги';
            }
            return 'Выбрать';
        }
        return 'Выберите время';
    }

    private updateHeaderText(): void {
        if (this.selectedDay) {
            this.headerTxt = moment(this.selectedDay)
                .locale('ru')
                .format('DD MMMM YYYY');
        }
    }

    selectDep(dep: Department) {
        this.pickedTalon = null;
        this.showCalendarIcon = true;
        if (dep.mergedKeyIds && dep.mergedKeyIds.length > 1) {
            this.selectedDeps = dep.mergedKeyIds;
        }
        this.headerTxt = `${moment(this.selectedDay).format('DD MMMM YYYY')}`;

        // if (dep?.keyid === -1) {
        //     this.selectedDep = null;
        //     this.depPicked = true;
        //     this.showDropdown = false;
        //     this.talonListFiltered = this.filterTalons();
        // } else {
        // Преобразуем Department в IDep правильно
        this.selectedDep = dep
            ? {
                  keyid: dep.keyid,
                  text: dep.text,
              }
            : null;

        this.showDropdown = false;
        this.talonListFiltered = this.filterTalons();
        // }
        this.activeDays = this.filterActiveDays();
    }

    filterTalons() {
        return this.talonListAll.filter((talon) => {
            return (
                talon.dtBegin?.getFullYear() === this.selectedDay?.year() &&
                talon.dtBegin?.getMonth() === this.selectedDay?.month() &&
                talon.dtBegin?.getDate() === this.selectedDay?.date() &&
                (this.selectedDep
                    ? this.selectedDeps.length > 1 &&
                      this.selectedDeps.includes(this.selectedDep.keyid)
                        ? this.selectedDeps.includes(talon.depid)
                        : talon.depid === this.selectedDep.keyid
                    : true)
            );
        });
    }

    get hasDoctorInfo(): boolean {
        return (
            Array.isArray(this.params?.infoDoc) &&
            this.params.infoDoc.length > 0
        );
    }
}
